// import React from 'react';

// const Loader = () => {
//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm z-50"
//       aria-label="Loading eJob platform data"
//     >
//       <div className="flex flex-col items-center">
//         {/* Dual-ring spinner */}
//         <div className="relative h-20 w-20">
//           <div className="absolute inset-0 rounded-full border-4 border-t-e-ride-purple border-b-customGreen border-l-transparent border-r-transparent animate-spin"></div>
//           <div className="absolute inset-2 rounded-full border-4 border-t-customBlue border-b-e-ride-purple border-l-transparent border-r-transparent animate-spin-slow"></div>
//         </div>
//         {/* Pulsing text */}
//         <div className="mt-4 text-lg font-semibold text-white animate-pulse">
//           Loading eJob...
//         </div>
//       </div>
//     </div>
//   );
// };

// // Add custom animation for slower spin
// const style = document.createElement('style');
// style.innerHTML = `
//   @keyframes spin-slow {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
//   .animate-spin-slow {
//     animation: spin-slow 2s linear infinite;
//   }
// `;
// document.head.appendChild(style);

// export default Loader;

import React from 'react'

const Loader = () => {
  return (
    <div className='text-center mt-50 font-bold'>
      Loading...
    </div>
  )
}

export default Loader
